var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-828 -868)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    transform: "translate(828 868)",
    fill: "#e6e9f4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.585 904.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.894,0a30.01,30.01,0,0,1-4.248,5.333,29.739,29.739,0,0,1-21.068,8.732A29.74,29.74,0,0,1,14.509,5.333,29.885,29.885,0,0,1,10.264,0H0A38.391,38.391,0,0,0,2.415,4.578a39.024,39.024,0,0,0,5.671,7.175,38.8,38.8,0,0,0,27.492,11.4,38.8,38.8,0,0,0,27.492-11.4,39.029,39.029,0,0,0,5.671-7.175A38.409,38.409,0,0,0,71.156,0Z",
    transform: "translate(3.337 54.676)",
    fill: "#bfc5db",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.991,45.59a29.825,29.825,0,0,0-7.983-27.744L45.338,32.514l-6.423,6.423-6.423-6.423L17.821,17.846A29.825,29.825,0,0,0,9.838,45.59H.573a39.006,39.006,0,0,1,18-39.841l6.663,6.663L38.915,26.091,52.593,12.412l6.663-6.663a39.342,39.342,0,0,1,7.175,5.674A38.908,38.908,0,0,1,77.256,45.59ZM38.915,9.086a29.987,29.987,0,0,0-4.836.391L26.6,2a38.943,38.943,0,0,1,24.63,0L43.75,9.477A29.977,29.977,0,0,0,38.915,9.086Z",
    transform: "translate(0 0)",
    fill: "#bfc5db"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.299ec9e8fc1a58d6a0ba4e66cc7174a4.svg";
export { ForwardRef as ReactComponent };